import AddressPhone from "~/components/Footer/AddressPhone";
import Bottom from "~/components/Footer/Bottom";
import Contacts from "~/components/Footer/Contacts";
import Links, { LinksNav } from "~/components/Footer/Links";
import Logo from "~/components/Footer/Logo";
import Middle from "~/components/Footer/Middle";
import NewsletterSignup from "~/components/Footer/NewsletterSignup";
import PaymentProviders from "~/components/Footer/PaymentProviders";
import Social from "~/components/Footer/Social";
import Top from "~/components/Footer/Top";

const Footer: React.FC = () => (
  <footer aria-label="Footer">
    <Top>
      <PaymentProviders />
      <NewsletterSignup />
    </Top>
    <Middle>
      <Links>
        <LinksNav
          header="Customer Service"
          links={[
            { href: "/users/sign_up", text: "Create An Account" },
            { href: "/order-status", text: "Track Order" },
            { href: "/contact-us", text: "Contact Us" },
            { href: "/shipping-policy", text: "Shipping Policy" },
            { href: "/tax-policy", text: "Tax Policy" },
            { href: "/about-us", text: "About Us" },
            { href: "/charity", text: "Charities We Support" },
            { href: "/faq", text: "FAQ" },
            { href: "/glossary-of-terms", text: "Glossary of Terms" },
            { href: "/returns", text: "Returns" },
            { href: "/privacy-policy", text: "Privacy Policy" },
            {
              href: "/privacy/do-not-sell",
              text: "Do Not Sell/Share My Information",
            },
            { href: "/reviews", text: "ShirtSpace Reviews" },
            { href: "/coupons", text: "ShirtSpace Coupons" },
            { href: "/blog", text: "ShirtSpace Blog" },
            { href: "/videos", text: "ShirtSpace Videos" },
          ]}
        />
        <LinksNav
          header="Popular Brands"
          links={[
            { href: "/gildan", text: "Gildan" },
            { href: "/port-company", text: "Port & Company" },
            { href: "/bella-canvas", text: "Bella + Canvas" },
            { href: "/hanes", text: "Hanes" },
            { href: "/next-level", text: "Next Level" },
            { href: "/comfort-colors", text: "Comfort Colors" },
            { href: "/sport-tek", text: "Sport-Tek" },
            { href: "/fruit-of-the-loom", text: "Fruit of the Loom" },
            { href: "/jerzees", text: "Jerzees" },
            { href: "/brands", text: "» See More" },
          ]}
        />
        <LinksNav
          header="Popular Categories"
          links={[
            { href: "/t-shirts", text: "T-Shirts" },
            { href: "/sweatshirts", text: "Sweatshirts" },
            { href: "/polos", text: "Polos" },
            { href: "/pants", text: "Pants" },
            { href: "/infants-toddlers", text: "Infants & Toddlers" },
            { href: "/athletic-apparel", text: "Athletic Apparel" },
            {
              href: "/tank-tops-sleeveless-shirts",
              text: "Tank Tops & Sleeveless Shirts",
            },
            { href: "/shorts", text: "Shorts" },
            { href: "/categories", text: "» See More" },
          ]}
        />
      </Links>
      <Contacts>
        <Logo />
        <AddressPhone />
        <Social />
      </Contacts>
    </Middle>
    <Bottom />
  </footer>
);

export default Footer;
